import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getAllPrompts = createAsyncThunk(
  'getAllPrompts',
  async (params, { rejectWithValue }) => {
    try {
      const { limit, offset, search, fields } = params;

      // Use URLSearchParams to construct query string
      const queryParams = new URLSearchParams();

      if (limit) queryParams.append('limit', limit);
      if (offset) queryParams.append('offset', offset);
      if (search?.trim()) queryParams.append('search', search.trim());
      if (fields) queryParams.append('fields', fields);

      const response = await request(
        `/api/v1/global-prompt/get-all-prompts?${queryParams.toString()}`,
        {
          method: 'GET',
          auth: true,
        }
      );

      if (response?.data) {
        return response;
      }

      return rejectWithValue(response?.error || 'Something went wrong');
    } catch (error) {
      return rejectWithValue(error?.message || 'Something went wrong');
    }
  }
);
